import { FC, SVGProps } from "react";

import __ from "web/Layout/Translations";

import FullPointsIcon from "web/assets/icons/payment-signet-full-points.svg";
import OwnFundsIcon from "web/assets/icons/payment-signet-own-funds.svg";
import PointsSurchargeIcon from "web/assets/icons/payment-signet-points-surcharge.svg";

import { PaymentFinancingMode } from "web/utils/page/product/universal/getPaymentFinancingMode";

import classes from "./paymentMethodSignet.scss";

interface IPaymentMethodSignetProps {
  mode: PaymentFinancingMode;
  className?: string;
  iconOnly?: boolean;
  labelClassName?: string;
  iconClassName?: string;
}

const ICONS: Record<
  Exclude<PaymentFinancingMode, "HIDDEN">,
  FC<SVGProps<SVGSVGElement>>
> = {
  FULL_POINTS: FullPointsIcon,
  POINTS_WITH_SURCHARGE: PointsSurchargeIcon,
  OWN_FUNDS: OwnFundsIcon,
};

const LABELS: Record<
  Exclude<PaymentFinancingMode, "HIDDEN" | "POINTS_WITH_SURCHARGE">,
  string
> = {
  FULL_POINTS: "Opłać punktami",
  OWN_FUNDS: "Środki własne",
};

const getLabel = (mode: Exclude<PaymentFinancingMode, "HIDDEN">) => {
  if (mode === "POINTS_WITH_SURCHARGE") {
    return `${__("Punkty")} + ${__("dopłata")}`;
  }

  return __(LABELS[mode]);
};

const PaymentMethodSignet: FC<IPaymentMethodSignetProps> = ({
  mode,
  className = "",
  iconOnly = false,
  labelClassName = "",
  iconClassName = "",
}) => {
  if (mode === "HIDDEN") {
    return null;
  }

  const Icon = ICONS[mode];

  return (
    <span
      className={`${classes.root} ${className}`}
      data-t1="payment_method_signet"
      data-t2={mode}
    >
      <Icon
        className={`${classes.icon} ${iconClassName}`}
        aria-hidden="true"
        focusable="false"
      />
      {!iconOnly && (
        <span className={`${classes.label} ${labelClassName}`}>
          {getLabel(mode)}
        </span>
      )}
    </span>
  );
};

export default PaymentMethodSignet;
